<template>
  <div>
    <p><strong>Dane osobowe</strong></p>
    <p>Informuję, że:</p>
    <ol>
      <li>
        Administratorem Twoich danych osobowych jest Kancelaria Radcy Prawnego
        Damian Michalak (adres biura: ul. Piękna 24/26a, 00-549 Warszawa, NIP:
        8381765174).
      </li>
      <li>Kontakt z Administratorem Danych: d.michalak@dmkancelaria.pl</li>
      <li>
        Zakres przetwarzanych danych osobowych określa zakres danych przesłanych
        za&nbsp;pomocą odpowiedniego formularza lub mailowo, przekazanych
        telefonicznie lub w formie wizyt&oacute;wki. Przetwarzanie danych
        osobowych może dotyczyć imienia i&nbsp;nazwiska, adresu poczty
        elektronicznej, adresu zamieszkania/siedziby, numeru telefonu, adresu IP
        komputera.
      </li>
      <li>
        Przetwarzamy Twoje dane wyłącznie w następujących celach i w oparciu o
        następujące podstawy prawne:
      </li>
    </ol>
    <p>KORESPONDENCJA TRADYCYJNA i E-MAILE</p>
    <p>
      W przypadku kierowania do Administratora za pośrednictwem poczty e-mail
      lub tradycyjnej korespondencji niezwiązanej z usługami świadczonymi na
      rzecz nadawcy lub inną zawartą z nim &nbsp;umową, &nbsp;dane &nbsp;osobowe
      &nbsp;zawarte &nbsp;w &nbsp;tej &nbsp;korespondencji &nbsp;są
      &nbsp;przetwarzane &nbsp;wyłącznie &nbsp;w celu komunikacji i zajęcia się
      sprawą, kt&oacute;rej dotyczy przesłana korespondencja.
    </p>
    <p>
      Podstawą prawną przetwarzania jest prawnie uzasadniony interes
      Administratora (art. 6 ust. 1 lit.f RODO) polegający na prowadzeniu
      korespondencji kierowanej do niego w związku z jego działalnością
      gospodarczą.
    </p>
    <p>
      Administrator &nbsp; przetwarza &nbsp; jedynie dane &nbsp; istotne &nbsp;
      dla &nbsp; sprawy, &nbsp; kt&oacute;rej &nbsp; dotyczy
      korespondencja.&nbsp;
    </p>
    <p>FORMULARZ KONTAKTOWY</p>
    <p>
      Administrator umożliwia także kontakt przy wykorzystaniu elektronicznego
      &nbsp; formularza &nbsp; kontaktowego. &nbsp; Skorzystanie z niego wymaga
      podania danych niezbędnych do nawiązania kontaktu z Administratorem.
      Podanie danych oznaczonych jako obowiązkowe jest wymagane w celu przyjęcia
      i obsługi zapytania, a ich niepodanie &nbsp; skutkuje &nbsp; brakiem
      &nbsp; możliwości &nbsp; obsługi. &nbsp; Podanie &nbsp; pozostałych &nbsp;
      danych &nbsp;jest dobrowolne. Dane osobowe są przetwarzane w celu
      identyfikacji nadawcy &nbsp;oraz obsługi jego &nbsp;zapytania przesłanego
      &nbsp; przez &nbsp; udostępniony &nbsp; formularz &ndash; podstawą &nbsp;
      prawną &nbsp; przetwarzania &nbsp; jest niezbędność &nbsp;przetwarzania
      &nbsp;do &nbsp;wykonania &nbsp;umowy &nbsp;o &nbsp;świadczenie
      &nbsp;usługi &nbsp;(art. &nbsp;6 &nbsp;ust. &nbsp;1 &nbsp;lit. &nbsp;b
      RODO); &nbsp;w zakresie &nbsp;danych &nbsp;podanych &nbsp;fakultatywnie
      &nbsp;podstawą &nbsp;prawną &nbsp;przetwarzania &nbsp;jest zgoda (art. 6
      ust. 1 lit. a RODO).
    </p>
    <p>KONTAKT TELEFONICZNY</p>
    <p>
      W &nbsp;przypadku &nbsp;kontaktu z Administratorem &nbsp;drogą
      &nbsp;telefoniczną, &nbsp; w &nbsp;sprawach niezwiązanych &nbsp;z
      &nbsp;zawartą &nbsp;umową &nbsp;lub &nbsp;świadczonymi &nbsp;usługami,
      &nbsp;Administrator &nbsp;może &nbsp;poprosić o podanie danych
      &nbsp;osobowych &nbsp;tylko &nbsp;w&oacute;wczas, &nbsp;gdy &nbsp;będzie
      &nbsp;to &nbsp;niezbędne &nbsp;do &nbsp;obsługi &nbsp;sprawy,
      kt&oacute;rej dotyczy kontakt telefoniczny.
    </p>
    <p>
      Podstawą prawną jest w takim wypadku prawnie uzasadniony interes
      Administratora (art. 6 ust. 1lit.f RODO) polegający na konieczności
      rozwiązania zgłoszonej sprawy związanej z prowadzoną przez niego
      działalnością gospodarczą.
    </p>
    <p>SERWIS LINKEDIN I INNE EWENTUALNE PORTALE SPOŁECZNOŚCIOWE</p>
    <p>
      Administrator prowadzi aktywność także przy użyciu portali
      społecznościowych &ndash; zwłaszcza LinkedIn, w efekcie czego przetwarza
      dane os&oacute;b odwiedzających profil lub angażujących się w
      poszczeg&oacute;lne aktywności serwisu (dyskusje, komentarze, polecenia,
      polubienia, etc.). Dane osobowe takich użytkownik&oacute;w są przetwarzane
      w celu umożliwienia im aktywności we wskazanym serwisie, w celach
      informowania o działalności Administratora, ze względ&oacute;w
      statystycznych czy też obsługi roszczeń.
    </p>
    <p>
      Podstawą prawną przetwarzania danych osobowych jest prawnie uzasadniony
      interes Administratora (art. 6 ust. 1 lit. f RODO), polegający na promocji
      własnej marki i świadczonych usług i na dochodzeniu roszczeń i obronie
      przed nimi.
    </p>
    <p>ZBIERANIE DANYCH W RAMACH KONTAKT&Oacute;W BIZNESOWYCH</p>
    <p>
      W toku prowadzonej działalności Administrator &nbsp;zbiera &nbsp;dane
      &nbsp;osobowe także podczas spotkań biznesowych, szkoleń, konferencji,
      etc. &ndash; np. poprzez wymianę wizyt&oacute;wek &ndash; w celach
      niezbędnych dla nawiązania i kontynuowania relacji biznesowych. Podstawą
      prawną przetwarzania jest w tym wypadku uzasadniony interes Administratora
      (art. 6 ust. 1lit.f RODO) polegający na tworzeniu sieci kontakt&oacute;w w
      związku z prowadzoną działalnością. Dane osobowe zebrane w ww.
      okolicznościach przetwarzane są wyłącznie w celu, dla kt&oacute;rego
      zostały zebrane.
    </p>
    <p>
      PRZETWARZANIE DANYCH OSOBOWYCH KONTRAHENT&Oacute;W I ZESPOŁU
      KONTRAHENT&Oacute;W
    </p>
    <p>
      W &nbsp;związku &nbsp;z &nbsp;zawieraniem &nbsp;um&oacute;w &nbsp;w
      &nbsp;ramach &nbsp;prowadzonej &nbsp;działalności, &nbsp;Administrator
      pozyskuje od kontrahent&oacute;w/klient&oacute;w dane os&oacute;b
      zaangażowanych w realizację ww. um&oacute;w w zakresie niezbędnym do
      zawarcia i realizacji umowy.
    </p>
    <p>
      Wskazane dane osobowe przetwarzane są w celu realizacji prawnie
      uzasadnionego interesu Administratora &nbsp; oraz &nbsp; jego
      &nbsp;kontrahenta (art. 6 &nbsp; ust. 1 &nbsp; lit.f &nbsp; RODO),
      polegającego &nbsp; na umożliwieniu wykonywania zawartej umowy.
      Przedmiotowe &nbsp;dane &nbsp;mogą &nbsp;być ujawniane podmiotom trzecim
      zaangażowanym w realizację umowy. Dane &nbsp;przetwarzane &nbsp;są
      &nbsp;przez &nbsp;okres &nbsp;niezbędny &nbsp;do &nbsp;realizacji
      &nbsp;powyższych &nbsp;interes&oacute;w oraz wykonania obowiązk&oacute;w
      wynikających z przepis&oacute;w.
    </p>
    <ol>
      <li>
        Podanie danych jest dobrowolne, ale konieczne do tego, aby realizować
        cele wskazane powyżej.
      </li>
      <li>
        Okres &nbsp;przetwarzania &nbsp;danych &nbsp;przez &nbsp;Administratora
        &nbsp;zależy &nbsp;od &nbsp;rodzaju &nbsp;świadczonej &nbsp;usługi i od
        celu &nbsp;przetwarzania. &nbsp;W przypadku, gdy podstawą przetwarzania
        jest zgoda &ndash; do momentu jej cofnięcia. W sytuacji
        &nbsp;przetwarzania &nbsp;danych na podstawie uzasadnionego &nbsp;
        interesu &nbsp; Administratora - &nbsp;przez &nbsp;okres
        &nbsp;umożliwiający &nbsp;realizację &nbsp;tego &nbsp;interesu. Okres
        &nbsp;przetwarzania &nbsp;danych &nbsp;może &nbsp;być &nbsp;przedłużony
        &nbsp;w &nbsp;przypadku, &nbsp;gdy &nbsp;przetwarzanie &nbsp;jest
        niezbędne do ustalenia lub dochodzenia roszczeń lub obrony przed
        roszczeniami. a po tym okresie -jedynie w przypadku i w zakresie, w
        jakim będą wymagać tego przepisy prawa. Dane osobowe przetwarzane przez
        radc&oacute;w prawnych w ramach wykonywania zawodu są przechowywane
        &nbsp;przez okres 10 &nbsp;lat &nbsp;od &nbsp;końca &nbsp;roku, &nbsp;w
        &nbsp;kt&oacute;rym &nbsp;zakończyło &nbsp;się postępowanie, w
        kt&oacute;rym dane osobowe zostały zgromadzone.
      </li>
      <li>
        W zakresie do tego koniecznym możemy przekazywać Twoje dane osobowe
        naszym dostawcom, kt&oacute;rym zlecimy usługi związane z przetwarzaniem
        danych osobowych, np. usługi IT, serwisy świadczące usługi utrzymania
        systemu informatycznego i hostingu, dostawca usługi poczty
        elektronicznej, a także podwykonawcom, księgowym, kurierom, operatorom
        pocztowym.
      </li>
      <li>Twoje dane nie będą przekazywane do państw trzecich, np. USA.</li>
      <li>
        Masz prawo do żądania dostępu do swoich danych osobowych, ich
        sprostowania, usunięcia lub ograniczenia przetwarzania, wycofania zgody
        prawo wniesienia sprzeciwu wobec przetwarzania, a także prawo do
        przenoszenia swoich danych oraz wniesienia skargi do organu nadzorczego,
        kt&oacute;rym jest Prezes Urzędu Ochrony Danych Osobowych.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
};
</script>
